import React from 'react';
import {Route, Redirect, withRouter} from 'react-router-dom';
import {connect} from "react-redux";

import {Ios, Android} from 'pages/os';
import Logo from 'components/common/app/logo';
import {Language} from 'components/common/app';


class Os extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {match, locale} = this.props;

        debugger;
        const renderStyle = () => {
            return (
                <link rel="stylesheet" type="text/css"
                      href={locale && locale.rtl ? './assets/styles/rtl.css' : './assets/styles/ltr.css'}/>
            )
        };

        return (
            <div className="page-content">
                {renderStyle()}
                <div className="register-page-title" style={{marginTop: '8%'}}>
                    <Logo height={60}/>
                </div>
                <div className='main-container' style={{padding: 0}}>
                    <Route path={`${match.url}/ios`}>
                        <Ios/>
                    </Route>
                    <Route path={`${match.url}/android`}>
                        <Android/>
                    </Route>

                    <Language size='small'/>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(Os));
